import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DrawerToggleService} from './drawer-toggle.service';
import {LOG_ENTRIES} from '../../../shared/log-helper/log-helper.service';
import {Log} from 'ng2-logger';
import {deprecate} from 'util';

// logger
const log = Log.create(LOG_ENTRIES.drawer_toggle.name);
log.color = LOG_ENTRIES.drawer_toggle.color;

@Component({
  selector: 'app-drawer-toggle',
  templateUrl: './drawer-toggle.component.html',
  styleUrls: ['./drawer-toggle.component.scss'],
})
export class DrawerToggleComponent implements OnInit {

  isDisplay = true;
  // use the service to replace this event emitter to make is more flexible
  @Output() showDrawer = new EventEmitter<boolean>();
  constructor(private drawerToggleService: DrawerToggleService) { }

  ngOnInit() {
    this.drawerToggleService.updateToggleStatus(this.isDisplay);
  }

  onDrawerToggle() {
    this.isDisplay = !this.isDisplay;
    this.showDrawer.emit(this.isDisplay);
    this.drawerToggleService.updateToggleStatus(this.isDisplay);
  }
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/drawer/drawer-toggle/drawer-toggle.component.ts